/* eslint-disable no-param-reassign */
import * as types from './types';
import api from '~/services/api';
import { clearFileUploadError } from '../errors/actions';
import {
  exportData, getTemplate, handleErrors, importData,
} from '../common';
import { convertToUrlParameters, removeEmptyValuesFromObj } from '~/utils';
import { newMomentDate, formatDateToServerFormat, formatTime } from '~/utils/moment';
import { SET_UPLOAD_SUCCESS } from '../errors/types';
import socketBuilder from '~/services/socketioService';
import i18n from '~/i18n';
import { getTenant } from '~/services/multiTenant';

const getEndpoints = {
  equipmentstatus: {
    url: '/dispatch/equipmentstatus',
    responseObject: 'equipment_status',
    typeAction: types.SET_EQUIPMENT_STATUS_LIST,
  },
  preventivetypes: {
    url: '/dispatch/preventivetype',
    responseObject: 'preventive_maintenance_type',
    typeAction: types.SET_PREVENTIVE_MAINTENANCE_TYPES_LIST,
  },
  equipmentsschedule: {
    url: '/dispatch/equipmentschedule',
    responseObject: 'equipment_schedule',
    typeAction: types.SET_EQUIPMENTS_SCHEDULES_LIST,
  },
  equipmentsschedulevalidationlist: {
    url: '/dispatch/equipmentschedule',
    responseObject: 'equipment_schedule',
    typeAction: types.SET_EQUIPMENTS_SCHEDULES_VALIDATION_LIST,
  },
  equipmentsschedulestatus: {
    url: '/dispatch/equipmentschedulestatus',
    responseObject: 'equipment_schedule_status',
    typeAction: types.SET_EQUIPMENT_SCHEDULE_STATUSES_LIST,
  },
  transportanomalyreport: {
    url: '/dispatch/transport_anomaly',
    responseObject: 'transport_anomaly_report',
    typeAction: types.SET_TRANSPORT_ANOMALY_LIST,
  },
  loadanomalyreport: {
    url: '/dispatch/load_anomaly',
    responseObject: 'load_anomaly_report',
    typeAction: types.SET_LOAD_ANOMALY_LIST,
  },
  anomalylog: {
    url: '/dispatch/anomalylog',
    responseObject: 'anomaly_log',
    typeAction: types.SET_ANOMALY_LOGS_LIST,
  },
  anomalylogcodes: {
    url: '/dispatch/anomalylog_codes',
    responseObject: 'anomaly_log_codes',
    typeAction: types.SET_ANOMALY_LOGS_CODES_LIST,
  },
  anomalylogcloud: {
    url: '/dispatch/anomalylog_cloud',
    responseObject: 'anomaly_log_cloud',
    typeAction: types.SET_ANOMALY_LOGS_CLOUD_LIST,
  },
  anomalytype: {
    url: '/dispatch/anomalytype',
    responseObject: 'anomaly_type',
    typeAction: types.SET_ANOMALY_TYPES_LIST,
  },
  loadmaterialmappings: {
    url: '/dispatch/loadmaterialmappings',
    responseObject: 'load_material_mappings',
    typeAction: types.SET_LOAD_MATERIAL_MAPPINGS_LIST,
  },
  loadallocations: {
    url: '/dispatch/loadallocations',
    responseObject: 'load_allocations',
    typeAction: types.SET_LOAD_ALLOCATIONS_LIST,
  },
  truckallocations: {
    url: '/dispatch/truckallocations',
    responseObject: 'truck_allocations',
    typeAction: types.SET_TRUCK_ALLOCATIONS_LIST,
  },
  dispatchOriginsTrucks: {
    url: '/dispatch/truckorigins',
    responseObject: 'truck_origins',
    typeAction: types.SET_DISPATCH_ORIGINS_TRUCKS,
  },
  dispatchOriginsExcavators: {
    url: '/dispatch/excavatororigins',
    responseObject: 'excavator_origins',
    typeAction: types.SET_DISPATCH_ORIGINS_EXCAVATORS,
  },
  dispatchDestinationTrucks: {
    url: '/dispatch/truckdestinations',
    responseObject: 'truck_destinations',
    typeAction: types.SET_DISPATCH_DESTINATION_TRUCKS,
  },
  dispatchDestinationElements: {
    url: '/dispatch/elementdestinations',
    responseObject: 'element_destinations',
    typeAction: types.SET_DISPATCH_DESTINATION_ELEMENTS,
  },
  autoAllocationLogs: {
    url: '/dispatch/autoalloclogs',
    responseObject: 'auto_allocation_logs',
    typeAction: types.SET_AUTO_ALLOCATION_LOGS,
  },
  operational_control_report: {
    url: 'dispatch/operational_control_report',
    responseObject: 'dispatch_operational_control_report',
    typeAction: types.SET_DISPATCH_OPERATION_CONTROL_LIST,
  },
  syncStatus: {
    url: '/syncstatus',
    responseObject: 'sync_status',
    typeAction: types.SET_SYNC_STATUS_LIST,
  },
  truck_indicators: {
    url: 'dispatch/indicators/trucks',
    responseObject: 'equipment_indicators',
    typeAction: types.SET_DISPATCH_TRUCK_INDICATORS_LIST,
  },
  loader_indicators: {
    url: 'dispatch/indicators/loaders',
    responseObject: 'equipment_indicators',
    typeAction: types.SET_DISPATCH_LOADER_INDICATORS_LIST,
  },
  alerts: {
    url: 'dispatch/alert_emitter',
    responseObject: 'alerts',
    typeAction: types.SET_ALERTS_LIST,
    tableName: 'alerts',
  },
  equipment_schedule_subelements: {
    url: 'dispatch/equipmentschedule/subelements',
    responseObject: 'subelements',
    typeAction: types.SET_EQUIPMENT_SCHEDULE_SUBELEMENTS_LIST,
  },
  perforator_equipment_schedule: {
    url: 'dispatch/equipmentschedule/equipments',
    responseObject: 'equipment_schedule',
    typeAction: types.SET_PERFORATOR_EQUIPMENT_SCHEDULE_LIST,
  },
  materialsmap: {
    url: 'dispatch/materials_map',
    responseObject: 'materials_map',
    typeAction: types.SET_MATERIALS_MAP,
  },
  blacklist_allocations: {
    url: 'dispatch/blacklist_allocations',
    responseObject: 'blacklist_allocations',
    typeAction: types.SET_BLACKLIST_ALLOCATIONS_LIST,
  },
  chatCategory: {
    url: 'dispatch/chat_category',
    responseObject: 'chat_categories',
    typeAction: types.SET_CHAT_CATEGORY_LIST,
  },
  chatResponse: {
    url: 'dispatch/chat_response',
    responseObject: 'chat_responses',
    typeAction: types.SET_CHAT_RESPONSE_LIST,
  },
  dispatchCodeIcons: {
    url: '/dispatch/code_icons',
    responseObject: 'code_icons_responses',
    typeAction: types.SET_DISPATCH_CODE_ICONS_LIST,
  },
  chatGroup: {
    url: '/dispatch/chat_groups',
    responseObject: 'chat_groups',
    typeAction: types.SET_CHAT_GROUP_LIST,
  },
  dynamicConfiguration: {
    url: '/dispatch/dynamicallocations',
    responseObject: 'load_allocation_dynamic_configuration',
    typeAction: types.SET_DYNAMIC_CONFIGURATION,
  },
  loadAllocationGroups: {
    url: '/dispatch/loadallocationsgroups',
    responseObject: 'load_allocations_groups',
    typeAction: types.SET_LOAD_ALLOCATIONS_GROUPS_LIST,
  },
};

const CODE_TYPE_MAINTENANCE = 0;
const CODE_GROUP_PREVENTIVE = 5;

export const incrementLoadingCounter = () => (dispatch) => {
  dispatch({
    type: types.INCREMENT_LOADING_COUNTER,
  });
};

export const decrementLoadingCounter = () => (dispatch) => {
  dispatch({
    type: types.DECREMENT_LOADING_COUNTER,
  });
};

export const getAll = ({
  domain,
  clearUploadError = true,
  all = false,
  filters = {},
  then = () => { },
  dispatchError = true,
  skipLoading = false,
  dispatchLoading = false,
  finallyCb = null,
}) => async (dispatch) => {
  if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: true });
  if (dispatchLoading) dispatch(incrementLoadingCounter());

  try {
    if (clearUploadError) {
      dispatch(clearFileUploadError());
    }
    const endpoint = getEndpoints[domain];
    if (all) filters.all = true;
    const queryString = convertToUrlParameters(filters);
    const endpointUrl = `${endpoint.url}?${queryString}`;

    const {
      data: {
        result: { [endpoint.responseObject]: data = [], ...rest },
      },
    } = await api.get(endpointUrl).finally(() => {
      if (finallyCb !== null) {
        finallyCb();
      }
    });

    dispatch({
      type: endpoint.typeAction,
      ...rest,
      payload: data,
    });

    then(data);
  } catch ({ response }) {
    if (dispatchError) {
      dispatch(handleErrors(response));
    } else {
      // eslint-disable-next-line no-console
      console.log(response);
    }
  }
  if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: false });
  if (dispatchLoading) dispatch(decrementLoadingCounter());
};

export const updateData = (
  domain,
  data,
  refreshData = true,
  all = false,
  filters = {},
) => async (dispatch) => {
  try {
    const items = data;
    const endpoint = getEndpoints[domain];
    const { status } = await api.post(`${endpoint.url}`, items);
    if (status === 200 && refreshData) {
      dispatch({ type: SET_UPLOAD_SUCCESS, payload: i18n.t('validation:SavedSuccess') });
      dispatch(getAll({ domain, all, filters }));
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response) {
      dispatch(handleErrors(err.response));
    }
  }
};

const setValues = (item, type) => (dispatch) => {
  const updateStatus = item.update_status === 'I' ? 'I' : 'U';
  dispatch({
    type,
    payload: {
      ...item,
      update_status: updateStatus,
    },
  });
};

export const getEquipmentStatuses = ({ dispatchLoading = false } = {}) => async (dispatch) => {
  dispatch(getAll({ domain: 'equipmentstatus', dispatchLoading }));
};

export const updateEquipmentStatus = ({ equipmentStatus, domain = 'equipmentstatus', finallyCb = null }) => async (dispatch) => {
  try {
    const endpoint = getEndpoints[domain];

    delete equipmentStatus.code_type_name;
    const newEquipStatus = equipmentStatus.length ? equipmentStatus : [equipmentStatus];
    const unixMillisecondsToSeconds = unix => Number(unix.valueOf().toString().slice(0, 10));

    const body = {
      equipment_status:
        newEquipStatus.map(i => (
          {
            ...i,
            duration: '00:00:01',
            start_timestamp: unixMillisecondsToSeconds(i.start_timestamp),
            start_date: formatDateToServerFormat(i.start_date),
            start_time: formatTime(i.start_time),
            update_status: 'I',
          }
        )),
    };
    const { status } = await api.post(`${endpoint.url}`, body);

    if (status === 200) {
      dispatch(getEquipmentStatuses());
      if (equipmentStatus.equip_type === 2) dispatch(getAll({ domain: 'dispatchOriginsTrucks' }));
      if (equipmentStatus.equip_type === 1) dispatch(getAll({ domain: 'dispatchOriginsExcavators' }));
      dispatch({
        type: types.SET_EQUIPMENT_STATUS_SAVED,
        payload: i18n.t('validation:SavedSuccess'),
      });
      dispatch({ type: SET_UPLOAD_SUCCESS, payload: i18n.t('validation:UpdateSentSuccessfully') });

      if (finallyCb !== null) {
        finallyCb();
      }
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
  }
};

export const setCurrentEquipmentStatus = (item, key = null, value = null) => (dispatch) => {
  const newItem = { ...item };

  if (key) {
    newItem[key] = value;
    if (key === 'code_type') {
      newItem.id_code_group = 0;
      newItem.id_code = 0;
    }
    if (key === 'id_code_group') {
      newItem.id_code = 0;
    }
    if (key === 'element_id') {
      newItem.point_id = 0;
    }
    if (key === 'id_operator_group') {
      newItem.id_operator = 0;
    }
  }

  dispatch({
    type: types.SET_EQUIPMENT_STATUS_ITEM,
    payload: newItem,
  });
};

export const setHighlightEquipmentStatus = ids => (dispatch) => {
  dispatch({ type: types.SET_HIGHLIGHT_EQUIPMENTS_STATUS, payload: ids });
};

export const setOriginalCurrentEquipmentStatus = item => (dispatch) => {
  dispatch({
    type: types.SET_ORIGINAL_EQUIPMENT_STATUS_ITEM,
    payload: item,
  });
};

export const setCurrentEquipmentStatusFilter = (key = null, value = null) => (dispatch) => {
  dispatch({
    type: types.SET_EQUIPMENT_STATUS_FILTER,
    payload: { key, value },
  });
};

export const restoreEquipmentStatusFilter = () => (dispatch) => {
  dispatch({ type: types.RESTORE_EQUIPMENT_STATUS_FILTER });
};

export const setCurrentEquipmentStatusFilterItemV3 = (key = null, value = null) => (dispatch) => {
  dispatch({
    type: types.SET_EQUIPMENT_STATUS_FILTER_ITEM_V3,
    payload: { key, value },
  });
};

export const setCurrentEquipmentStatusFilterV3 = filter => (dispatch) => {
  dispatch({
    type: types.SET_EQUIPMENT_STATUS_FILTER_V3,
    payload: filter,
  });
};


export const clearEquipmentStatusFilterV3 = () => (dispatch) => {
  dispatch({ type: types.CLEAR_EQUIPMENT_STATUS_FILTER_V3 });
};


// Equipment Schedules
export const getPreventiveTypes = () => async dispatch => dispatch(getAll({ domain: 'preventivetypes' }));

export const getEquipmentsSchedules = (filter = {}, validationList = false) => async (dispatch) => {
  const newStartDate = filter.startDate
    ? formatDateToServerFormat(filter.startDate)
    : formatDateToServerFormat(newMomentDate());
  const newEndDate = filter.endDate
    ? formatDateToServerFormat(filter.endDate)
    : formatDateToServerFormat(newMomentDate());

  const serverFormattedFilter = {
    start_date: newStartDate,
    end_date: newEndDate,
    equip: filter.equip || 0,
    equip_group: filter.equipGroup || 0,
    equip_type: filter.equipType || 0,
    element: filter.element || 0,
    sub_element: filter.subElement || 0,
    status_id: filter.status_id || 0,
  };

  dispatch(getAll({
    domain: validationList
      ? 'equipmentsschedulevalidationlist' : 'equipmentsschedule',
    filters: removeEmptyValuesFromObj(serverFormattedFilter),
  }));
};

export const getPerforatorEquipmentScheduleList = (filters = {}) => async (dispatch) => {
  dispatch(getAll({
    domain: 'perforator_equipment_schedule',
    filters,
  }));
};
export const getEquipmentsSchedulesTemplate = () => getTemplate('dispatch/equipmentschedule');
export const importEquipmentsSchedules = (file, filters) => importData(
  'dispatch/equipmentschedule',
  file,
  () => getEquipmentsSchedules(filters),
);
export const exportEquipmentsSchedules = () => (dispatch, getState) => {
  const { dispatch: { currentEquipmentSchedulesFilter } } = getState();
  dispatch(exportData('dispatch/equipmentschedule', currentEquipmentSchedulesFilter));
};

export const getEquipmentScheduleStatuses = () => async (dispatch) => {
  dispatch(getAll({
    domain: 'equipmentsschedulestatus',
  }));
};

export const getAlerts = (filters = {}) => async (dispatch) => {
  dispatch(getAll({
    domain: 'alerts',
    filters,
  }));
};

export const setAlerts = (alerts = []) => (dispatch) => {
  dispatch({
    type: types.SET_ALERTS_LIST,
    payload: alerts,
  });
};

export const updateAlerts = data => async dispatch => dispatch(updateData('alerts', data, true));

export const getAnomalyLogsCloud = (filter = {}) => async (dispatch) => {
  const newDate = filter.date
    ? formatDateToServerFormat(filter.date)
    : formatDateToServerFormat(newMomentDate());

  const serverFormattedFilter = {
    date: newDate,
  };

  dispatch(getAll({
    domain: 'anomalylogcloud',
    filters: removeEmptyValuesFromObj(serverFormattedFilter),
  }));
};

export const getAnomalyLogsCodes = (filter = {}) => async (dispatch) => {
  const newDate = filter.date.format('DD/MM/YYYY HH:mm:ss');

  const serverFormattedFilter = {
    date: newDate,
  };

  dispatch(getAll({
    domain: 'anomalylogcodes',
    filters: removeEmptyValuesFromObj(serverFormattedFilter),
  }));
};

export const getTransportAnomaly = (filter = {}) => async (dispatch) => {
  const newDate = filter.date.format('DD/MM/YYYY HH:mm:ss');

  const serverFormattedFilter = {
    date: newDate,
    hide_interrupted_or_deleted: true,
  };

  dispatch(getAll({
    domain: 'transportanomalyreport',
    filters: serverFormattedFilter,
  }));
};

export const setTransportAnomalyListValues = (item, key, value) => (dispatch) => {
  const newItem = {
    ...item,
    [key]: value,
  };

  dispatch(setValues(newItem, types.SET_TRANSPORT_ANOMALY_LIST_VALUE));
};

export const updateTransportAnomalyList = ({
  data, ogData, filters, saveLog = false,
}) => async (dispatch) => {
  const ObjWithoutKeys = data.map(({
    start_date, start_time, end_date, end_time, ...rest
  }) => ({ ...rest }));

  try {
    const items = ObjWithoutKeys.filter(d => d.update_status);

    const endpoint = getEndpoints.transportanomalyreport;

    const formatToDatetime = (date, time) => `${formatDateToServerFormat(date)}${formatTime(time)}`;

    const formattedOgData = ogData.map((item) => {
      const {
        start_date, start_time, end_date, end_time, ...rest
      } = item;

      return {
        ...rest,
        start_time: formatToDatetime(start_date, start_time),
        end_time: formatToDatetime(end_date, end_time),
      };
    });


    let body = {
      [endpoint.responseObject]: items,
    };

    if (saveLog) {
      body = {
        ...body,
        original_payload: formattedOgData,
      };
    }

    const { status } = await api.post(`${endpoint.url}`, body);
    if (status === 200) {
      dispatch(getTransportAnomaly(filters));
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
  }
};

export const resetOriginalTransportAnomalyList = () => ({
  type: types.RESET_TRANSPORT_ANOMALY_LIST,
});

export const getLoadAnomaly = (filter = {}) => async (dispatch) => {
  const newDate = filter.date.format('DD/MM/YYYY HH:mm:ss');

  const serverFormattedFilter = {
    date: newDate,
    hide_interrupted_or_deleted: true,
  };

  dispatch(getAll({
    domain: 'loadanomalyreport',
    filters: serverFormattedFilter,
  }));
};

export const setLoadAnomalyListValues = (item, key, value) => (dispatch) => {
  const newItem = {
    ...item,
    [key]: value,
  };

  dispatch(setValues(newItem, types.SET_LOAD_ANOMALY_LIST_VALUE));
};

export const updateLoadAnomalyList = ({
  data, ogData, filters = {},
}) => async (dispatch) => {
  const anomalyObjData = data.map(({
    start_date, start_time, end_date, end_time, ...rest
  }) => ({
    start_datetime: start_date + start_time,
    end_datetime: end_date + end_time,
    ...rest,
  }));

  try {
    const items = anomalyObjData.filter(d => d.update_status);

    const endpoint = getEndpoints.loadanomalyreport;

    const formatToDatetime = (date, time) => `${formatDateToServerFormat(date)}${formatTime(time)}`;

    const formattedOgData = ogData.map((item) => {
      const {
        start_date, start_time, end_date, end_time, ...rest
      } = item;

      return {
        ...rest,
        start_time: formatToDatetime(start_date, start_time),
        end_time: formatToDatetime(end_date, end_time),
      };
    });

    const body = {
      [endpoint.responseObject]: items,
      original_payload: formattedOgData,
    };

    const { status } = await api.post(`${endpoint.url}`, body);
    if (status === 200) {
      dispatch(getLoadAnomaly(filters));
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
  }
};

export const resetOriginalLoadAnomalyList = () => ({
  type: types.RESET_LOAD_ANOMALY_LIST,
});

export const getAnomalyLogs = (filter = {}) => async (dispatch) => {
  const newDate = filter.date.format('DD/MM/YYYY HH:mm:ss');

  const serverFormattedFilter = {
    date: newDate,
    equip: filter.equip || 0,
    equips: filter.equips || [],
    equip_group: filter.equipGroup || 0,
    equip_type: filter.equipType || 0,
    anomaly_type: filter.anomalyType || 0,
    status: filter.status || false,
    groupCloudPoints: true,
  };

  dispatch(getAll({
    domain: 'anomalylog',
    filters: removeEmptyValuesFromObj(serverFormattedFilter),
  }));
};

export const removeAnomalyLog = item => (dispatch) => {
  const newItem = {
    ...item,
    status: false,
  };
  dispatch(setValues(newItem, types.SET_ANOMALY_LOGS_VALUE));
};

export const removeAllAnomalyLogsFromList = (anomalyLogsList,
  exception_type = 15) => (dispatch) => {
  const newAnomalyLogsList = anomalyLogsList.map((item) => {
    const newItem = {
      ...item,
      status: false,
      exception_type,
      update_status: 'U',
    };
    return newItem;
  });
  dispatch({
    type: types.SET_ANOMALY_LOGS_LIST,
    payload: newAnomalyLogsList,
  });
};


export const updateAnomalyLogs = (data, filters = {}) => async (dispatch) => {
  try {
    const items = data
      .filter(d => d.update_status);

    const endpoint = getEndpoints.anomalylog;

    const body = {
      [endpoint.responseObject]: items,
    };

    const { status } = await api.post(`${endpoint.url}`, body);
    if (status === 200) {
      dispatch(getAnomalyLogs(filters));
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
  }
};

export const getEquipmentScheduleSubelements = filters => getAll({ domain: 'equipment_schedule_subelements', filters });

export const getAnomalyTypes = () => async (dispatch) => {
  dispatch(getAll({
    domain: 'anomalytype',
  }));
};

export const updateEquipmentsSchedules = (
  data, filters = {}, perforator = false,
) => async (dispatch) => {
  try {
    const items = data
      .filter(d => d.update_status)
      .map((d) => {
        const {
          isDirty, id, ...rest
        } = d;

        rest.start_date = formatDateToServerFormat(rest.start_date);
        if (rest.update_status !== 'I') return { id, ...rest };
        return rest;
      });
    if (items.length === 0) return;
    const endpoint = getEndpoints.equipmentsschedule;

    const body = {
      [endpoint.responseObject]: items,
    };
    const { status } = await api.post(`${endpoint.url}`, body);
    if (status === 200) {
      if (perforator) {
        dispatch(getPerforatorEquipmentScheduleList());
        dispatch(getEquipmentScheduleSubelements());
      } else {
        dispatch(getEquipmentsSchedules(filters));
      }
      dispatch({ type: SET_UPLOAD_SUCCESS, payload: i18n.t('validation:UpdateSentSuccessfully') });
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
    dispatch(getEquipmentsSchedules(filters));
  }
};

export const setEquipmentsScheduleValue = (item, key, value) => (dispatch) => {
  let newCodeGroupId = item.code_groups_id;
  let newCodeId = item.codes_id;
  let newPreventiveType = item.preventive_type;

  if (key === 'code_types_id') {
    newCodeGroupId = 0;
    newCodeId = 0;
    newPreventiveType = value !== CODE_TYPE_MAINTENANCE
      ? 0 : newPreventiveType;
  } else if (key === 'code_groups_id') {
    newCodeId = 0;
    newPreventiveType = value !== CODE_GROUP_PREVENTIVE
      ? 0 : newPreventiveType;
  }

  const newItem = {
    ...item,
    code_groups_id: newCodeGroupId,
    codes_id: newCodeId,
    preventive_type: newPreventiveType,
    [key]: value,
  };
  dispatch(setValues(newItem, types.SET_EQUIPMENTS_SCHEDULE_VALUE));
};

export const resetEquipmentsSchedules = () => (dispatch) => {
  dispatch({ type: types.RESET_EQUIPMENTS_SCHEDULES });
};

export const addEquipmentsSchedule = data => dispatch => dispatch({
  type: types.ADD_EQUIPMENTS_SCHEDULE,
  payload: data,
});

export const getDispatchOperationalControl = filters => (
  getAll({ domain: 'operational_control_report', filters })
);


export const getTemplateDispatchOperationalControl = () => (
  getTemplate('dispatch/operational_control_report')
);

export const importDispatchOperationalControl = (file, filters) => importData(
  'dispatch/operational_control_report',
  file,
  () => getDispatchOperationalControl({
    ...filters,
    start_date: formatDateToServerFormat(filters.start_date),
    end_date: formatDateToServerFormat(filters.end_date),
  }),
);

export const addDispatchOperationalControl = data => (dispatch, getState) => dispatch({
  type: types.ADD_DISPATCH_OPERATIONAL_CONTROL,
  payload: {
    ...data,
    id: -(getState().dispatch.operationalControl.length + 1),
    update_status: 'I',
  },
});

export const restoreOperationalControl = () => ({
  type: types.RESTORE_DISPATCH_OPERATIONAL_CONTROL,
});

export const updateDispatchOperationalControl = () => async (dispatch, getState) => {
  try {
    const { operationalControl, currentOperationalFilter } = getState().dispatch;
    const changes = operationalControl.filter(opContr => opContr.update_status);
    const endpoint = getEndpoints.operational_control_report;
    const body = { [endpoint.responseObject]: changes };
    const { status } = await api.post(endpoint.url, body);

    if (status === 200) {
      const filters = {
        ...currentOperationalFilter,
        start_date: formatDateToServerFormat(currentOperationalFilter.start_date),
        end_date: formatDateToServerFormat(currentOperationalFilter.end_date),
      };
      dispatch(getDispatchOperationalControl(filters));
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
  }
};

export const setOperationalControlValues = operationalControlItem => ({
  type: types.SET_OPERATIONAL_CONTROL_VALUES,
  payload: {
    ...operationalControlItem,
    update_status: operationalControlItem.update_status || 'U',
    exception_type: operationalControlItem.update_status === 'I' ? 13 : 15,
  },
});

export const deleteOperationalControlValues = operationalControlItem => ({
  type: types.SET_OPERATIONAL_CONTROL_VALUES,
  payload: {
    ...operationalControlItem,
    update_status: 'D',
    exception_type: 16,
  },
});

export const setCurrentEquipmentSchedulesFilter = filter => (dispatch) => {
  dispatch({
    type: types.SET_EQUIPMENT_SCHEDULES_FILTER,
    payload: filter,
  });

  dispatch(getEquipmentsSchedules(filter));
};

export const restoreEquipmentSchedulesFilter = () => (dispatch) => {
  dispatch({ type: types.RESTORE_EQUIPMENT_SCHEDULES_FILTER });
  dispatch(getEquipmentsSchedules());
};

export const setCurrentAnomalyLogsFilter = filter => (dispatch) => {
  dispatch({
    type: types.SET_ANOMALY_LOGS_FILTER,
    payload: filter,
  });
};

export const setCurrentOperationalControlFilter = filters => ({
  type: types.SET_CURRENT_OPERATIONAL_CONTROL_FILTER,
  payload: filters,
});

export const clearCurrentOperationalControlFilter = () => ({
  type: types.CLEAR_CURRENT_OPERATIONAL_CONTROL_FILTER,
});

export const restoreAnomalyLogsFilter = () => (dispatch) => {
  dispatch({ type: types.RESTORE_ANOMALY_LOGS_FILTER });
};

export const getLoadMaterialMappings = (
  filters = {}, then = () => { }, finallyCb = null,
) => (dispatch) => {
  const serverFormattedFilters = {
    equip_id: filters.equipmentId || 0,
    material_id: filters.materialId || 0,
    load_allocation_id: filters.loadAllocationId || 0,
  };
  dispatch(getAll({
    domain: 'loadmaterialmappings',
    filters: removeEmptyValuesFromObj(serverFormattedFilters),
    then,
    finallyCb,
  }));
};

export const clearLoadMaterialMappings = () => (dispatch) => {
  dispatch({ type: types.CLEAR_LOAD_MATERIAL_MAPPINGS_LIST });
};

export const setLoadMaterialMappingsValue = (item, key, value) => (dispatch) => {
  const newItem = {
    ...item,
    [key]: value,
  };
  dispatch(setValues(newItem, types.SET_LOAD_MATERIAL_MAPPINGS_VALUE));
};

export const resetLoadMaterialMappings = () => (dispatch) => {
  dispatch({ type: types.RESET_LOAD_MATERIAL_MAPPINGS });
};

export const updateLoadMaterialMappings = (data, filters = {}) => async (dispatch) => {
  try {
    const items = data
      .filter(d => d.update_status);

    const endpoint = getEndpoints.loadmaterialmappings;

    const body = {
      [endpoint.responseObject]: items,
    };

    const { status } = await api.post(`${endpoint.url}`, body);
    if (status === 200) {
      dispatch(getLoadMaterialMappings(filters));
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
  }
};

export const setLoadMaterialMappingsItem = item => (dispatch) => {
  dispatch({ type: types.SET_LOAD_MATERIAL_MAPPINGS_ITEM, payload: item });
};

export const getLoadAllocations = ({ dispatchLoading = false } = {}) => (dispatch) => {
  dispatch(getAll({
    domain: 'loadallocations',
    dispatchLoading,
  }));
};

export const getTruckAllocations = (
  { dispatchLoading = false, finallyCb = null } = {},
) => (dispatch) => {
  dispatch(getAll({ domain: 'truckallocations', dispatchLoading, finallyCb }));
};

export const getDispatchOriginsTrucks = ({ dispatchLoading = false } = {}) => (dispatch) => {
  dispatch(getAll({ domain: 'dispatchOriginsTrucks', dispatchLoading }));
};

export const getSyncStatus = (filters, then, dispatchLoading = false) => (dispatch) => {
  dispatch(getAll({
    domain: 'syncStatus', filters, then, dispatchLoading,
  }));
};

export const getDispatchOriginsExcavators = ({ dispatchLoading = false } = {}) => (dispatch) => {
  dispatch(getAll({ domain: 'dispatchOriginsExcavators', dispatchLoading }));
};

export const getDispatchDestinationsTrucks = () => (dispatch) => {
  dispatch(getAll({ domain: 'dispatchDestinationTrucks' }));
};

export const getDispatchDestinationsElements = () => (dispatch) => {
  dispatch(getAll({ domain: 'dispatchDestinationElements' }));
};

export const updateIsTruckAllocationLoading = payload => ({
  type: types.IS_TRUCK_ALLOCATION_LOADING,
  payload,
});

export const updateLoadAllocations = ({
  item,
  materialMappings = [],
  refresh = true,
  skipLoading = false,
  dispatchLoading = false,
  finallyCb = null,
}) => async (dispatch) => {
  try {
    if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: true });
    if (dispatchLoading) dispatch(incrementLoadingCounter());

    const endpoint = getEndpoints.loadallocations;

    const body = {
      [endpoint.responseObject]: [{
        ...item,
        load_material_mappings: materialMappings,
      }],
    };

    const { status } = await api.post(`${endpoint.url}`, body).finally(() => finallyCb && finallyCb());

    if (status === 200 && refresh) {
      dispatch(getLoadAllocations());
      dispatch(getTruckAllocations());
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
    if (dispatchLoading) dispatch(decrementLoadingCounter());
    if (finallyCb) finallyCb();
  }

  if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: false });
};

export const setPendingTruckAllocationUpdate = (item, skipLoading = false) => async (dispatch) => {
  if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: true });

  dispatch({
    type: types.SET_PENDING_TRUCK_ALLOCATION_UPDATE,
    payload: item,
  });
};


export const updateTruckAllocations = ({
  item,
  key,
  value,
  refresh = true,
  skipLoading = false,
  refreshOrigins = false,
  refreshDestinations = false,
  dispatchLoading = false,
}) => async (dispatch) => {
  try {
    if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: true });
    if (dispatchLoading) dispatch(incrementLoadingCounter());

    const endpoint = getEndpoints.truckallocations;

    const body = {
      [endpoint.responseObject]: [{
        ...item,
        [key]: value || null,
      }],
    };

    const { status } = await api.post(`${endpoint.url}`, body);
    if (status === 200 && refresh) {
      dispatch(getTruckAllocations({
        finally: () => {
          dispatch(updateIsTruckAllocationLoading(false));
        },
      }));
      if (refreshOrigins) {
        dispatch(getDispatchOriginsTrucks());
      }
      if (refreshDestinations) {
        dispatch(getDispatchDestinationsTrucks());
      }
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
    if (dispatchLoading) dispatch(decrementLoadingCounter());
  }

  if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: false });
};

export const deallocateAllLoadAllocations = (
  refresh = true, skipLoading = false, dispatchLoading = false,
) => async (dispatch) => {
  try {
    if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: true });
    if (dispatchLoading) dispatch(incrementLoadingCounter());

    const body = {
      all: true,
      allocation_ids: [],
    };
    const { status } = await api.post('/dispatch/deallocateloads', body);

    if (status === 200 && refresh) {
      dispatch(getLoadAllocations());
      dispatch(getTruckAllocations());
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
    if (dispatchLoading) dispatch(decrementLoadingCounter());
  }
  if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: false });
};

export const deallocateLoadAllocations = ({
  id,
  refresh = true,
  skipLoading = false,
  dispatchLoading = false,
}) => async (dispatch) => {
  try {
    if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: true });
    if (dispatchLoading) dispatch(incrementLoadingCounter());

    const body = {
      all: false,
      allocation_ids: [id],
    };
    const { status } = await api.post('/dispatch/deallocateloads', body);
    if (status === 200 && refresh) {
      dispatch(getLoadAllocations());
      dispatch(getTruckAllocations());
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
    if (dispatchLoading) dispatch(decrementLoadingCounter());
  }
  if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: false });
};

export const deallocateTruckAllocations = ({
  id,
  refresh = true,
  skipLoading = false,
  dispatchLoading = false,
}) => async (dispatch) => {
  if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: true });
  if (dispatchLoading) dispatch(incrementLoadingCounter());

  try {
    const body = {
      all: false,
      allocation_ids: [id],
    };
    const { status } = await api.post('/dispatch/deallocatetrucks', body);

    if (status === 200 && refresh) {
      dispatch(getTruckAllocations());
      dispatch(getDispatchOriginsTrucks());
      dispatch(getDispatchDestinationsTrucks());
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
    if (dispatchLoading) dispatch(decrementLoadingCounter());
  }

  if (skipLoading) dispatch({ type: 'SKIP_LOADING', payload: false });
};

export const setLoadAllocationPriority = (item,
  list,
  priority = 1,
  dispatchLoading = false) => async (dispatch) => {
  try {
    if (dispatchLoading) dispatch(incrementLoadingCounter());

    const body = {
      allocation_id: item.id,
      priority,
    };

    const { status } = await api.post('/dispatch/updatepriority', body);

    if (status === 200) {
      dispatch(getLoadAllocations());
    }
  } catch ({ response }) {
    dispatch(handleErrors(response));
  }
  if (dispatchLoading) dispatch(decrementLoadingCounter());
};

export const setSelectedTruckAllocation = truckAllocation => (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_TRUCK_ALLOCATION,
    payload: truckAllocation,
  });
};

export const setSelectedPerforatorAllocation = perforatorAllocation => (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_PERFORATOR_ALLOCATION,
    payload: perforatorAllocation,
  });
};

export const setSelectedLoadAllocation = loadAllocation => (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_LOAD_ALLOCATION,
    payload: loadAllocation,
  });
};

export const setTruckAllocation = (truckAllocation, allocateTo) => (dispatch) => {
  dispatch({
    type: types.SET_TRUCK_ALLOCATION,
    payload: { truckAllocation, allocateTo },
  });
};

export const setSelectedLoadAllocationValues = newItem => (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_LOAD_ALLOCATION_VALUES,
    payload: newItem,
  });
};

export const setSelectedTruckOrigin = truckOrigin => (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_TRUCK_ORIGIN,
    payload: truckOrigin,
  });
};

export const setSelectedLoadOrigin = loadOrigin => (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_LOAD_ORIGIN,
    payload: loadOrigin,
  });
};

export const setSelectedTruckDestination = truckDestination => (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_TRUCK_DESTINATION,
    payload: truckDestination,
  });
};

export const setSelectedElementDestination = elementDestination => (dispatch) => {
  dispatch({
    type: types.SET_SELECTED_ELEMENT_DESTINATION,
    payload: elementDestination,
  });
};

export const getAutoAllocationLogs = (startDate, endDate) => async (dispatch) => {
  const serverFormattedFilter = {
    start_date: formatDateToServerFormat(startDate),
    end_date: formatDateToServerFormat(endDate),
  };

  dispatch(getAll({
    domain: 'autoAllocationLogs',
    filters: removeEmptyValuesFromObj(serverFormattedFilter),
  }));
};


export const getTruckIndicators = () => getAll({ domain: 'truck_indicators', dispatchError: false });
export const getLoaderIndicators = () => getAll({ domain: 'loader_indicators', dispatchError: false });


export const setDispatchSocketConnection = token => (dispatch) => {
  if (token) {
    const tenant = getTenant();
    const socket = socketBuilder(token, `/${tenant}/dispatch`);

    if (!socket) return;

    socket.on('connect', () => {
    });
    socket.on('disconnect', () => {
    });
    socket.on('truck_indicators', () => {
      dispatch(getTruckIndicators());
    });
    socket.on('loader_indicators', () => {
      dispatch(getLoaderIndicators());
    });

    dispatch({
      type: types.SET_DISPATCH_SOCKET_CONNECTION,
      payload: socket,
    });
  }
};

export const closeDispatchSocketConnection = () => (dispatch, getState) => {
  const { socket } = getState().dispatch;

  if (socket) {
    socket.close();
    dispatch({
      type: types.SET_DISPATCH_SOCKET_CONNECTION,
      payload: null,
    });
  }
};

export const getMaterialsMap = () => (dispatch) => {
  dispatch(getAll({ domain: 'materialsmap' }));
};

export const getBlacklistAllocations = ({ dispatchLoading = false } = {}) => (dispatch) => {
  dispatch(getAll({ domain: 'blacklist_allocations', dispatchLoading }));
};

export const createBlacklistAllocationsItem = newData => ({
  type: types.CREATE_BLACKLIST_ALLOCATIONS_ITEM,
  payload: {
    ...newData,
    update_status: 'I',
  },
});

export const setBlacklistAllocationsValues = item => (dispatch) => {
  const updateStatus = item.update_status === 'I' ? 'I' : 'U';
  dispatch({
    type: types.SET_BLACKLIST_ALLOCATIONS_VALUES,
    payload: {
      ...item,
      update_status: updateStatus,
    },
  });
};

export const deleteBlacklistAllocationsItem = item => ({
  type: types.DELETE_BLACKLIST_ALLOCATIONS_ITEM,
  payload: {
    ...item,
    isDirty: true,
    update_status: 'D',
  },
});

export const updateBlacklistAllocations = data => async (dispatch) => {
  dispatch(updateData('blacklist_allocations', data));
};

export const resetBlacklistAllocations = () => (dispatch) => {
  dispatch({ type: types.RESET_BLACKLIST_ALLOCATIONS });
};

export const setPermissionAlert = isOpen => ({
  type: 'SET_PERMISSION_ALERT',
  payload: isOpen,
});

export const createChatCategoryItem = newData => ({
  type: types.CREATE_CHAT_CATEGORY_ITEM,
  payload: {
    ...newData,
    update_status: 'I',
  },
});

export const setChatCategoryValues = item => (dispatch) => {
  const updateStatus = item.update_status === 'I' ? 'I' : 'U';
  dispatch({
    type: types.SET_CHAT_CATEGORY_VALUES,
    payload: {
      ...item,
      update_status: updateStatus,
    },
  });
};

export const updateChatCategory = data => async (dispatch) => {
  dispatch(updateData('chatCategory', data));
};

export const resetChatCategory = () => (dispatch) => {
  dispatch({ type: types.RESET_CHAT_CATEGORY });
};

export const deleteChatCategoryItem = item => ({
  type: types.DELETE_CHAT_CATEGORY_ITEM,
  payload: {
    ...item,
    isDirty: true,
    update_status: 'D',
  },
});

export const getChatCategory = () => async (dispatch) => {
  dispatch(getAll({
    domain: 'chatCategory',
  }));
};

export const createChatResponseItem = newData => ({
  type: types.CREATE_CHAT_RESPONSE_ITEM,
  payload: {
    ...newData,
    update_status: 'I',
  },
});

export const setChatResponseValues = item => (dispatch) => {
  const updateStatus = item.update_status === 'I' ? 'I' : 'U';
  dispatch({
    type: types.SET_CHAT_RESPONSE_VALUES,
    payload: {
      ...item,
      update_status: updateStatus,
    },
  });
};

export const updateChatResponse = data => async (dispatch) => {
  dispatch(updateData('chatResponse', data));
};

export const resetChatResponse = () => (dispatch) => {
  dispatch({ type: types.RESET_CHAT_RESPONSE });
};

export const deleteChatResponseItem = item => ({
  type: types.DELETE_CHAT_RESPONSE_ITEM,
  payload: {
    ...item,
    isDirty: true,
    update_status: 'D',
  },
});

export const getChatResponse = () => async (dispatch) => {
  dispatch(getAll({
    domain: 'chatResponse',
  }));
};

export const updateDispatchCodeIcons = data => async (dispatch) => {
  dispatch(updateData('dispatchCodeIcons', data));
};

export const getDispatchCodeIcons = () => async (dispatch) => {
  dispatch(getAll({
    domain: 'dispatchCodeIcons',
  }));
};

export const getChatGroup = () => async (dispatch) => {
  dispatch(getAll({ domain: 'chatGroup' }));
};

export const updateChatGroup = data => async (dispatch) => {
  dispatch(updateData('chatGroup', data));
};

export const deleteChatGroup = data => async (dispatch) => {
  dispatch(updateData('chatGroup', data));
};

export const getDynamicConfiguration = ({
  finallyCb = null,
} = {}) => async (dispatch) => {
  dispatch(getAll({ domain: 'dynamicConfiguration', finallyCb }));
};

export const bulkUpdateDynamic = ({ payload, loadAfterRequest = null }) => async (dispatch) => {
  try {
    const { status } = await api.put('/dispatch/dynamicallocations', payload);

    if (status === 200 && loadAfterRequest !== null) {
      loadAfterRequest.forEach(action => dispatch(action()));
    }
  } catch {
    console.error('dynamicallocations error');
  }
};

export const bulkInsertDynamic = ({ payload, loadAfterRequest = null }) => async (dispatch) => {
  try {
    const { status } = await api.post('/dispatch/dynamicallocations', payload);

    if (status === 200 && loadAfterRequest !== null) {
      loadAfterRequest.forEach(action => dispatch(action()));
    }
  } catch {
    console.error('dynamicallocations error');
  }
};

export const updateDynamicConfiguration = ({
  payload,
  loadAfterRequest = null,
}) => async (dispatch) => {
  try {
    const { status } = await api.patch('/dispatch/dynamicallocations', payload);

    if (status === 200 && loadAfterRequest !== null) {
      loadAfterRequest.forEach(action => dispatch(action()));
    }
    dispatch(getAll({ domain: 'dynamicConfiguration' }));
  } catch {
    console.error('dynamicallocations error');
  }
};

export const getLoadAllocationsGroups = ({
  finallyCb = null,
} = {}) => async (dispatch) => {
  dispatch(getAll({ domain: 'loadAllocationGroups', finallyCb }));
};
